import React, { Component } from 'react'
import LoadingDefault from '../../Elements/Loading/LoadingDefault'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, TextField, MenuItem, Alert, FormControl } from '@mui/material'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class VerzoekToewijzingForm extends Component {
    constructor(props) {
        super(props)

        let ingangsDatum = null
        let toewijzingsDatum = null
        if (this.props.item && this.props.item.ingangs_datum) {
            ingangsDatum = this.props.kedo
                .utils()
                .dateFormat(this.props.item.ingangs_datum, 'YYYY-MM-DD')
        }
        if (this.props.item && this.props.item.toewijzings_datum) {
            toewijzingsDatum = this.props.kedo
                .utils()
                .dateFormat(this.props.item.toewijzings_datum, 'YYYY-MM-DD')
        }

        this.state = {
            saving: false,
            errors: false,
            product_categorie: this.props.item
                ? this.props.item.product_categorie
                : null,
            begindatum: ingangsDatum,
            product_code: this.props.item ? this.props.item.product_code : null,
            statusaanlevering: this.props.item
                ? this.props.item.statusaanlevering
                : null,
            toewijzing_nummer: this.props.item
                ? this.props.item.toewijzing_nummer
                : null,
            toewijzings_datum: toewijzingsDatum,
        }

        this.submit = this.submit.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    submit() {
        const api = this.props.kedo.api()

        let data = {
            volume: this.state.volume,
            product_code: this.state.product_code,
            verwijzer_type: this.state.verwijzertype,
            product_categorie: this.state.product_categorie,
            verwijzernaam: this.state.verwijzer_naam,
            eenheid: this.state.eenheid,
            frequentie: this.state.frequentie,
            budget: this.state.budget,
            beschikkingnummer: this.state.beschikkingnummer,
            beschikkingingangsdatum: this.state.beschikkingingangsdatum,
            raamcontract: this.state.raamcontract,
            ingangsdatum: this.state.ingangsdatum,
            einddatum: this.state.einddatum,
            zorgverlenercode: this.state.zorgverlenercode,
        }

        this.setState({ saving: true })
        api.post('/module/ijwiwmo/vot/' + this.props.dossierId, data)
            .then((response) =>
                this.setState({ saving: false }, () => this.props.onClose(true))
            )
            .catch((errResponse) =>
                this.setState({
                    errors: api.getErrorFromApiCall(errResponse.response),
                })
            )
    }

    render() {
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'xl'}
                fullWidth
                title={' Toevoegen verzoek toewijzing '}
                onClose={() => this.props.onClose()}
                headerClose={() => this.props.onClose()}
                contentProps={{ dividers: true }}
                actions={
                    <>
                        <StyledButton onClick={this.submit}>
                            {this.state.saving ? (
                                <LoadingDefault size={'sm'} />
                            ) : (
                                <FontAwesomeIcon icon={faSave} />
                            )}
                            &nbsp; {kedo.t('Save')}
                        </StyledButton>
                        <StyledButton
                            onClick={() => this.props.onClose()}
                            color="secondary"
                        >
                            {kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
            >
                <Box
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { my: 1 },
                        '& .MuiFormControl-root': { my: 1 },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    {this.state.errors && (
                        <Alert severity="warning">
                            Er is iets mis gegaan bij het opslaan.
                        </Alert>
                    )}

                    {this.state.errors !== false ? (
                        <Alert severity={'warning'}>
                            Er is iets mis gegaan bij het opslaan.
                        </Alert>
                    ) : null}
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className={'required'}>
                            Ingangsdatum
                        </FormInputLabel>
                        <TextField
                            type="date"
                            fullWidth
                            size="small"
                            name="ingangsdatum"
                            value={this.state.ingangsdatum}
                            onChange={this.onChange}
                            error={!!this.state.errors?.ingangsdatum}
                            helperText={this.state.errors?.ingangsdatum}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className={'required'}>
                            Einddatum
                        </FormInputLabel>
                        <TextField
                            type="date"
                            fullWidth
                            size="small"
                            name="einddatum"
                            value={this.state.einddatum}
                            onChange={this.onChange}
                            error={!!this.state.errors?.eindDatum}
                            helperText={this.state.errors?.eindDatum}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className={'required'}>
                            Product categorie
                        </FormInputLabel>
                        <TextField
                            fullWidth
                            size="small"
                            name="product_categorie"
                            value={this.state.product_categorie}
                            onChange={this.onChange}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>Product code</FormInputLabel>
                        <TextField
                            fullWidth
                            size="small"
                            name="product_code"
                            value={this.state.product_code}
                            onChange={this.onChange}
                            error={!!this.state.errors?.product_code}
                            helperText={this.state.errors?.product_code}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel htmlFor="eenheid">
                            Eenheid
                        </FormInputLabel>
                        <TextField
                            select
                            fullWidth
                            size="small"
                            name="eenheid"
                            value={this.state.eenheid}
                            onChange={this.onChange}
                            error={!!this.state.errors?.eenheid}
                            helperText={this.state.errors?.eenheid}
                        >
                            <MenuItem value="">Selecteer</MenuItem>
                            <MenuItem value="01">Minuut</MenuItem>
                            <MenuItem value="04">Uur</MenuItem>
                            <MenuItem value="14">Etmaal</MenuItem>
                            <MenuItem value="16">Dagdeel (4 uur)</MenuItem>
                            <MenuItem value="82">Stuks</MenuItem>
                            <MenuItem value="83">Euro&apos;s</MenuItem>
                            <MenuItem value="84">Stuks (inspanning)</MenuItem>
                        </TextField>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>Frequentie</FormInputLabel>
                        <TextField
                            select
                            label="Frequentie"
                            fullWidth
                            size="small"
                            name="frequentie"
                            value={this.state.frequentie}
                            onChange={this.onChange}
                            error={!!this.state.errors?.frequentie}
                            helperText={this.state.errors?.frequentie}
                        >
                            <MenuItem value="">Selecteer</MenuItem>
                            <MenuItem value="1">Per dag</MenuItem>
                            <MenuItem value="2">Per week</MenuItem>
                            <MenuItem value="4">Per maand</MenuItem>
                            <MenuItem value="6">
                                Totaal binnen geldigheidsduur beschikking
                            </MenuItem>
                        </TextField>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>Volume</FormInputLabel>
                        <TextField
                            fullWidth
                            size="small"
                            name="volume"
                            value={this.state.volume}
                            onChange={this.onChange}
                            error={!!this.state.errors?.volume}
                            helperText={
                                this.state.errors?.volume ||
                                'Als het een bedrag betreft, dan dit invullen IN CENTEN (1 euro = 100)'
                            }
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className="control-label">
                            Type Verwijzer
                        </FormInputLabel>
                        <TextField
                            select
                            fullWidth
                            size="small"
                            name="verwijzertype"
                            value={this.state.verwijzertype}
                            onChange={this.onChange}
                            error={!!this.state.errors?.typeVerwijzer}
                            helperText={this.state.errors?.typeVerwijzer}
                        >
                            <MenuItem value="">Choose an option</MenuItem>
                            <MenuItem value="01">Gemeente</MenuItem>
                            <MenuItem value="02">Huisarts</MenuItem>
                            <MenuItem value="03">Jeugdarts</MenuItem>
                            <MenuItem value="04">
                                Gecertificeerde instelling
                            </MenuItem>
                            <MenuItem value="05">Medisch specialist</MenuItem>
                            <MenuItem value="06">Zelfverwijzer</MenuItem>
                            <MenuItem value="07">Onbekend</MenuItem>
                            <MenuItem value="08">
                                Rechter, Raad voor de Kinderbescherming of
                                Officier van Justitie
                            </MenuItem>
                        </TextField>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className="control-label">
                            Verwijzer naam
                        </FormInputLabel>
                        <TextField
                            fullWidth
                            size="small"
                            name="verwijzer_naam"
                            value={this.state.verwijzer_naam}
                            onChange={this.onChange}
                            error={!!this.state.errors?.verwijzerNaam}
                            helperText={this.state.errors?.verwijzerNaam}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className="control-label">
                            ZorgverlenerCode
                        </FormInputLabel>
                        <TextField
                            fullWidth
                            size="small"
                            name="zorgverlenercode"
                            value={this.state.zorgverlenercode}
                            onChange={this.onChange}
                            error={!!this.state.errors?.zorgverlenerCode}
                            helperText={this.state.errors?.zorgverlenerCode}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className="control-label">
                            Raamcontract
                        </FormInputLabel>
                        <TextField
                            select
                            label="Raamcontract"
                            fullWidth
                            size="small"
                            name="raamcontract"
                            value={this.state.raamcontract}
                            onChange={this.onChange}
                        >
                            <MenuItem value="">Choose an option</MenuItem>
                            <MenuItem value="1">Ja</MenuItem>
                            <MenuItem value="2">Nee</MenuItem>
                        </TextField>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>Beschikkingsnummer</FormInputLabel>
                        <TextField
                            label="Beschikkingsnummer"
                            fullWidth
                            size="small"
                            name="beschikkingnummer"
                            value={this.state.beschikkingnummer}
                            onChange={this.onChange}
                            error={!!this.state.errors?.Beschikkingsnummer}
                            helperText={this.state.errors?.Beschikkingsnummer}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className="control-label">
                            Beschikking ingangsdatum
                        </FormInputLabel>
                        <TextField
                            type="date"
                            fullWidth
                            size="small"
                            name="beschikkingingangsdatum"
                            value={this.state.beschikkingingangsdatum}
                            onChange={this.onChange}
                            error={!!this.state.errors?.beschikkingingangsdatum}
                            helperText={
                                this.state.errors?.beschikkingingangsdatum
                            }
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className="control-label">
                            Budget
                        </FormInputLabel>
                        <TextField
                            fullWidth
                            size="small"
                            name="budget"
                            value={this.state.budget}
                            onChange={this.onChange}
                            error={!!this.state.errors?.budget}
                            helperText={this.state.errors?.budget}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className="control-label">
                            Commentaar
                        </FormInputLabel>
                        <TextField
                            fullWidth
                            size="small"
                            multiline
                            minRows={3}
                            name="comment"
                            value={this.state.comment}
                            onChange={this.onChange}
                        />
                    </FormControl>
                </Box>
            </AppDialog>
        )
    }
}

export default VerzoekToewijzingForm
